import { withLenses } from '@dhmk/zustand-lens';
import create from 'zustand';
import { isDebug } from '@core/debug';
import { createContext } from '@core/zustand';
import { createGuestSpeakerSlice } from '@player/features/guestSpeaker/model';
import { createSlice as createPlayerModalSlice } from '@player/features/modal/modalRegistry';
import { actions } from './actions';
import { addDevtool } from './helpers';
import { initialState } from './initialState';
/**
 *
 */
export function createInitStateCreator(extraState) {
    return (set, get) => {
        const { actions: customActions, ...customState } = extraState?.(set, get) ?? {};
        return {
            ...initialState,
            ...createGuestSpeakerSlice(),
            ...createPlayerModalSlice(),
            ...customState,
            actions: {
                ...actions(set, get),
                ...customActions,
            },
        };
    };
}
/**
 * Creates a Player zustand store with initial state and actions.
 *
 * Note: Do not attempt for persistence in Player's store.
 * Its hard to sync multiple instances across Storyblocks on the same page.
 * Global's store is likely a better place to go.
 *
 * @param extraState Custom state to be merged with initial state.
 * @returns A zustand store
 */
export const createStore = (extraState) => {
    let createState = createInitStateCreator(extraState);
    createState = withLenses(createState);
    // Note: devtool must be configured before other middleware.
    if (isDebug()) {
        createState = addDevtool(createState);
    }
    return create(createState);
};
export const { Provider, useStore, useStoreApi } = createContext();
